
import './App.css';
import { useEffect, useState } from 'react';
import Whatsappfields from './Whatsappfields';

function App() {
  const queryString = window.location.search;
  const [urlParams, setUrlParams] = useState(new URLSearchParams(queryString));
  const [fetchResponse, setFetchResponse] = useState({});
  const [orderedData, setOrderedData] = useState({});
  const [wacode, setWACode] = useState("");



/* BEGIN OF functions for building the categorytree */

function  buildCatTable(parent, level, allCategoryObjects, catTree) {//recursive function for building categories
  let cats = []

  cats = getConnectedCategories(allCategoryObjects, parent);
      
  if (cats){

  cats.map(cat => {    
    console.log('cats.map first entry')              
    catTree.push({ level: level, category: cat })        
    buildCatTable(cat.id, level + 1, allCategoryObjects, catTree);        
  })
}
};        

function getConnectedCategories(allCategoryObjects, parentid) { // return all categories which belong to the given parent
  let cats =  []
  allCategoryObjects.map(currlevel => {
    
    if ( currlevel.parentId == parentid) {
      cats.push(currlevel);
    }
  });       

  return cats;
}
  
/* END OF BUILDING FUNCTIONS FOR CATEGORYTREE */



  const fetchData = async () => {

    let whatsappid = urlParams.get("wa")
    const response = await fetch("https://api2-demo.joobster.at/external/whatsapp/" +whatsappid, {
      /*headers: {
        'Access-Control-Allow-Origin' : '*', 
        'mode' : 'no-cors'
      }
        */
    });
    const data = await response.json();
    console.log("output fetch is: ", data)
    if (data.status!="error"){
    setFetchResponse(data);
    let cattree = []
    buildCatTable(null, 0, data.whatsapp.hierarchy, cattree)
    console.log("cattree new with levels: ", cattree)
    setOrderedData(cattree)
    }


  };

  useEffect(() => {
    
    
    if (urlParams.get("wa")){
    setWACode(urlParams.get("wa"))
    fetchData();
    }

  }, [])

  return (
    <div className="App">
      {
       urlParams.toString() && fetchResponse && Object.entries(fetchResponse).length > 0 ?
       <Whatsappfields wacode={wacode} company={fetchResponse.company} whatsapp={fetchResponse.whatsapp} hierarchy={fetchResponse.whatsapp.hierarchy} orderedHierarchy={orderedData} /> 
       : <h1>Sorry, keine Daten gefunden!</h1>
      }
      </div>

  );
}

export default App;
